// تولیدشده با packages/i18n/scripts/sync-errors.mjs از docs/06-contracts/error-codes.md — ویرایش دستی نکنید.
export const ERROR_CODE_MESSAGE_KEYS: Readonly<Record<string, string>> = {
  "PHX-ACC-0101": "error.acc_chart_structure_invalid",
  "PHX-ACC-0102": "error.acc_account_code_invalid",
  "PHX-ACC-0103": "error.acc_account_code_taken",
  "PHX-ACC-0104": "error.acc_account_has_activity",
  "PHX-ACC-0105": "error.acc_account_parent_invalid",
  "PHX-ACC-0106": "error.acc_chart_import_invalid",
  "PHX-ACC-0107": "error.acc_detail_code_taken",
  "PHX-ACC-0108": "error.acc_detail_invalid",
  "PHX-ACC-0201": "error.acc_role_unknown",
  "PHX-ACC-0202": "error.acc_mapping_invalid",
  "PHX-ACC-0301": "error.acc_source_entry_not_failed",
  "PHX-ACC-0302": "error.acc_posting_settings_invalid",
  "PHX-ACC-0401": "error.acc_fiscal_year_invalid",
  "PHX-ACC-0402": "error.acc_period_invalid_transition",
  "PHX-ACC-0403": "error.acc_period_locked",
  "PHX-ACC-0404": "error.acc_period_reopen_owner_only",
  "PHX-ACC-0501": "error.acc_export_nothing",
  "PHX-ACC-0502": "error.acc_export_invalid_transition",
  "PHX-ACC-0503": "error.acc_export_profile_invalid",
  "PHX-ACC-0504": "error.acc_export_profile_taken",
  "PHX-ACC-0505": "error.acc_export_file_unreadable",
  "PHX-ACC-0506": "error.acc_export_schedule_invalid",
  "PHX-ACC-0601": "error.acc_bank_account_invalid",
  "PHX-ACC-0602": "error.acc_bank_account_taken",
  "PHX-ACC-0701": "error.acc_expense_category_invalid",
  "PHX-ACC-0702": "error.acc_expense_category_taken",
  "PHX-ACC-0703": "error.acc_expense_invalid",
  "PHX-ACC-0801": "error.acc_manual_journal_invalid",
  "PHX-ACC-0802": "error.acc_manual_journal_unbalanced",
  "PHX-ACC-0803": "error.acc_control_account_manual_entry",
  "PHX-ACC-0804": "error.acc_journal_invalid_transition",
  "PHX-ACC-0805": "error.acc_self_approval_forbidden",
  "PHX-ACC-0806": "error.acc_opening_balance_not_allowed",
  "PHX-ACC-0807": "error.acc_year_close_not_allowed",
  "PHX-ACC-0808": "error.acc_year_already_closed",
  "PHX-ACC-0809": "error.acc_bank_statement_invalid",
  "PHX-ACC-0810": "error.acc_bank_match_invalid",
  "PHX-BIL-0101": "error.visit_invalid_transition",
  "PHX-BIL-0102": "error.visit_line_invoiced",
  "PHX-BIL-0103": "error.visit_line_invalid_transition",
  "PHX-BIL-0104": "error.visit_not_open",
  "PHX-BIL-0105": "error.visit_reopen_window_expired",
  "PHX-BIL-0106": "error.visit_reopened_add_only",
  "PHX-BIL-0107": "error.visit_close_blocked",
  "PHX-BIL-0108": "error.visit_service_not_selectable",
  "PHX-BIL-0201": "error.visit_line_amount_required",
  "PHX-BIL-0202": "error.visit_line_not_priced",
  "PHX-BIL-0203": "error.tax_rate_missing",
  "PHX-BIL-0204": "error.discount_invalid",
  "PHX-BIL-0205": "error.discount_approval_required",
  "PHX-BIL-0206": "error.approval_invalid",
  "PHX-BIL-0207": "error.restriction_reason_required",
  "PHX-BIL-0208": "error.amount_override_forbidden",
  "PHX-BIL-0209": "error.approval_required",
  "PHX-BIL-0301": "error.invoice_nothing_to_issue",
  "PHX-BIL-0302": "error.invoice_immutable",
  "PHX-BIL-0303": "error.invoice_patient_temporary",
  "PHX-BIL-0304": "error.invoice_payer_invalid",
  "PHX-BIL-0401": "error.billing_settings_invalid",
  "PHX-BIL-0501": "error.payment_session_required",
  "PHX-BIL-0502": "error.payment_method_not_allowed",
  "PHX-BIL-0503": "error.payment_amount_invalid",
  "PHX-BIL-0504": "error.payment_allocation_exceeds",
  "PHX-BIL-0505": "error.invoice_not_payable",
  "PHX-BIL-0506": "error.change_exceeds_cash",
  "PHX-BIL-0507": "error.balance_requires_debt",
  "PHX-BIL-0508": "error.payment_reference_required",
  "PHX-BIL-0509": "error.online_payment_unavailable",
  "PHX-BIL-0510": "error.payment_link_closed",
  "PHX-BIL-0511": "error.payment_gateway_failed",
  "PHX-BIL-0520": "error.cash_register_invalid",
  "PHX-BIL-0521": "error.cash_session_already_open",
  "PHX-BIL-0522": "error.cash_session_invalid_transition",
  "PHX-BIL-0523": "error.cash_session_unresolved_payments",
  "PHX-BIL-0524": "error.discrepancy_reason_required",
  "PHX-BIL-0601": "error.invoice_void_not_allowed",
  "PHX-BIL-0602": "error.credit_note_exceeds",
  "PHX-BIL-0603": "error.credit_note_invalid",
  "PHX-BIL-0604": "error.refund_exceeds_credit",
  "PHX-BIL-0605": "error.refund_offline",
  "PHX-BIL-0606": "error.refund_invalid_transition",
  "PHX-BIL-0607": "error.refund_method_invalid",
  "PHX-BIL-0701": "error.deposit_invalid_transition",
  "PHX-BIL-0702": "error.deposit_exists",
  "PHX-BIL-0703": "error.wallet_insufficient",
  "PHX-BIL-0704": "error.credit_unavailable",
  "PHX-BIL-0801": "error.package_not_sellable",
  "PHX-BIL-0802": "error.package_type_unsupported",
  "PHX-BIL-0803": "error.package_sale_invalid_transition",
  "PHX-BIL-0804": "error.package_policy_forbids",
  "PHX-BIL-0805": "error.package_extension_exceeds",
  "PHX-BIL-0806": "error.package_credits_in_use",
  "PHX-BIL-0807": "error.package_transfer_target_invalid",
  "PHX-BIL-0901": "error.quote_invalid_transition",
  "PHX-BIL-0902": "error.quote_invalid",
  "PHX-BIL-0903": "error.quote_expired",
  "PHX-BIL-0904": "error.quote_otp_invalid",
  "PHX-BIL-0905": "error.quote_signer_unavailable",
  "PHX-BIL-1001": "error.installment_invalid",
  "PHX-BIL-1002": "error.installment_down_payment",
  "PHX-BIL-1003": "error.installment_plan_exists",
  "PHX-BIL-1004": "error.installment_invalid_transition",
  "PHX-BIL-1005": "error.write_off_invalid",
  "PHX-BIL-1101": "error.cheque_invalid",
  "PHX-BIL-1102": "error.cheque_duplicate",
  "PHX-BIL-1103": "error.cheque_invalid_transition",
  "PHX-BIL-1104": "error.cheque_sayyad_rejected",
  "PHX-BIL-1201": "error.pos_unavailable",
  "PHX-BIL-1202": "error.pos_payment_failed",
  "PHX-BIL-1203": "error.payment_invalid_transition",
  "PHX-BIL-1204": "error.bank_deposit_invalid",
  "PHX-BIL-1301": "error.settlement_file_invalid",
  "PHX-BIL-1302": "error.reconciliation_invalid_transition",
  "PHX-BIL-1401": "error.membership_not_sellable",
  "PHX-BIL-1402": "error.membership_invalid_transition",
  "PHX-BIL-1403": "error.membership_exists",
  "PHX-BIL-1501": "error.wallet_promotion_invalid",
  "PHX-BIL-1601": "error.product_not_sellable",
  "PHX-BIL-1602": "error.product_insufficient_stock",
  "PHX-BIL-1603": "error.product_sale_invalid",
  "PHX-BIL-1701": "error.offline_operation_reused",
  "PHX-BIL-1702": "error.offline_conflict_closed",
  "PHX-BIL-1703": "error.offline_resolution_invalid",
  "PHX-BIL-1801": "error.e_invoice_disabled",
  "PHX-BIL-1802": "error.e_invoice_not_applicable",
  "PHX-BIL-1803": "error.e_invoice_not_retryable",
  "PHX-BIL-1804": "error.economic_code_missing",
  "PHX-BIL-1805": "error.e_invoice_original_missing",
  "PHX-BIL-1901": "error.organization_account_invalid",
  "PHX-BIL-1902": "error.organization_statement_invalid",
  "PHX-BIL-1903": "error.organization_statement_invalid_transition",
  "PHX-CAT-0101": "error.category_depth_exceeded",
  "PHX-CAT-0102": "error.category_code_taken",
  "PHX-CAT-0103": "error.category_not_empty",
  "PHX-CAT-0104": "error.category_parent_invalid",
  "PHX-CAT-0105": "error.category_not_found",
  "PHX-CAT-0201": "error.service_code_taken",
  "PHX-CAT-0202": "error.service_code_locked",
  "PHX-CAT-0203": "error.service_delete_forbidden",
  "PHX-CAT-0204": "error.service_invalid_transition",
  "PHX-CAT-0205": "error.specialty_unknown",
  "PHX-CAT-0206": "error.national_code_unknown",
  "PHX-CAT-0301": "error.duration_invalid",
  "PHX-CAT-0302": "error.provider_unknown",
  "PHX-CAT-0311": "error.tariff_book_version_unknown",
  "PHX-CAT-0312": "error.tariff_book_invalid_transition",
  "PHX-CAT-0313": "error.k_coefficient_missing",
  "PHX-CAT-0314": "error.service_out_of_tariff_book",
  "PHX-CAT-0331": "error.price_above_approved_tariff",
  "PHX-CAT-0341": "error.contract_code_taken",
  "PHX-CAT-0342": "error.contract_invalid",
  "PHX-CAT-0343": "error.contract_invalid_transition",
  "PHX-CAT-0344": "error.contract_beneficiary_exists",
  "PHX-CAT-0345": "error.contract_cap_exceeded",
  "PHX-CAT-0351": "error.currency_price_list_exists",
  "PHX-CAT-0352": "error.currency_invalid",
  "PHX-CAT-0401": "error.resource_tag_unknown",
  "PHX-CAT-0402": "error.form_template_unknown",
  "PHX-CAT-0403": "error.restriction_service_unknown",
  "PHX-CAT-0404": "error.bom_item_invalid",
  "PHX-CAT-0501": "error.tax_profile_code_taken",
  "PHX-CAT-0502": "error.tax_profile_unknown",
  "PHX-CAT-0503": "error.tax_rate_invalid",
  "PHX-CAT-0504": "error.tax_rate_date_taken",
  "PHX-CAT-0601": "error.package_code_taken",
  "PHX-CAT-0602": "error.package_invalid",
  "PHX-CAT-0603": "error.package_invalid_transition",
  "PHX-CAT-0604": "error.package_regular_price_missing",
  "PHX-CAT-0701": "error.price_effective_date_past",
  "PHX-CAT-0702": "error.price_entry_date_taken",
  "PHX-CAT-0703": "error.pricing_method_not_supported",
  "PHX-CAT-0704": "error.price_out_of_range",
  "PHX-CAT-0705": "error.price_override_forbidden",
  "PHX-CAT-0706": "error.branch_price_list_exists",
  "PHX-CAT-0707": "error.branch_unknown",
  "PHX-CAT-0708": "error.provider_group_code_taken",
  "PHX-CAT-0709": "error.provider_group_member_taken",
  "PHX-CAT-0710": "error.provider_group_unknown",
  "PHX-CAT-0711": "error.bulk_change_empty",
  "PHX-CAT-0712": "error.bulk_change_not_revertible",
  "PHX-CAT-0801": "error.price_not_defined",
  "PHX-CAT-0802": "error.pricing_not_supported_yet",
  "PHX-CAT-0901": "error.discount_code_taken",
  "PHX-CAT-0902": "error.discount_rule_invalid",
  "PHX-CAT-0903": "error.discount_invalid_transition",
  "PHX-CAT-0904": "error.coupon_code_taken",
  "PHX-CAT-0905": "error.discount_evaluation_expired",
  "PHX-CFG-0101": "error.setting_scope_not_allowed",
  "PHX-CFG-0102": "error.setting_value_invalid",
  "PHX-CFG-0201": "error.module_not_toggleable",
  "PHX-CFG-0301": "error.custom_field_key_taken",
  "PHX-CFG-0401": "error.cfg_pack_code_taken",
  "PHX-CFG-0402": "error.cfg_pack_manifest_invalid",
  "PHX-CFG-0403": "error.cfg_pack_version_state",
  "PHX-CFG-0404": "error.cfg_pack_second_approver_required",
  "PHX-CFG-0405": "error.cfg_pack_release_notes_required",
  "PHX-CFG-0406": "error.cfg_pack_apply_in_progress",
  "PHX-CFG-0407": "error.cfg_pack_section_required",
  "PHX-CFG-0501": "error.cfg_parameter_set_invalid",
  "PHX-CFG-0502": "error.cfg_parameter_set_code_taken",
  "PHX-CFG-0601": "error.cfg_rule_reason_required",
  "PHX-CFG-0602": "error.cfg_sample_approver_role",
  "PHX-CFG-0603": "error.cfg_sample_not_pending",
  "PHX-CFG-0604": "error.cfg_rule_override_not_pending",
  "PHX-CHN-0101": "error.chn_settings_invalid",
  "PHX-CHN-0102": "error.chn_origin_invalid",
  "PHX-CHN-0103": "error.chn_web_form_invalid",
  "PHX-CHN-0104": "error.chn_challenge_failed",
  "PHX-CHN-0105": "error.chn_review_invalid",
  "PHX-CHN-0106": "error.chn_ticket_invalid",
  "PHX-CHN-0107": "error.chn_ticket_category_invalid",
  "PHX-CHN-0108": "error.chn_call_invalid",
  "PHX-CHN-0109": "error.chn_ticket_settings_invalid",
  "PHX-CHN-0110": "error.chn_custom_domain_invalid",
  "PHX-CHN-0201": "error.chn_web_form_rate_limited",
  "PHX-CHN-0202": "error.chn_review_not_publishable",
  "PHX-CHN-0203": "error.chn_review_invalid_transition",
  "PHX-CHN-0204": "error.chn_review_not_eligible",
  "PHX-CHN-0205": "error.chn_public_page_unavailable",
  "PHX-CHN-0206": "error.chn_ticket_invalid_transition",
  "PHX-CHN-0207": "error.chn_ticket_category_unavailable",
  "PHX-CHN-0208": "error.chn_ticket_category_code_taken",
  "PHX-CHN-0209": "error.chn_custom_domain_taken",
  "PHX-CHN-0210": "error.chn_custom_domain_not_verified",
  "PHX-CHN-0211": "error.chn_custom_domain_limit",
  "PHX-CHN-0300": "error.chn_media_invalid",
  "PHX-CHN-0301": "error.chn_gallery_full",
  "PHX-CHN-0302": "error.chn_slug_invalid",
  "PHX-CHN-0303": "error.chn_media_consent_required",
  "PHX-CHN-0401": "error.chn_origin_not_allowed",
  "PHX-CHN-0402": "error.chn_portal_section_disabled",
  "PHX-CLN-0101": "error.cln_record_entry_invalid",
  "PHX-CLN-0102": "error.cln_vitals_implausible",
  "PHX-CLN-0103": "error.cln_vitals_invalid",
  "PHX-CLN-0104": "error.cln_reason_required",
  "PHX-CLN-0105": "error.cln_template_invalid",
  "PHX-CLN-0106": "error.cln_quick_phrase_taken",
  "PHX-CLN-0107": "error.cln_diagnosis_invalid",
  "PHX-CLN-0108": "error.cln_rule_invalid",
  "PHX-CLN-0109": "error.cln_service_record_invalid",
  "PHX-CLN-0110": "error.cln_diagnosis_code_taken",
  "PHX-CLN-0111": "error.cln_plan_invalid",
  "PHX-CLN-0112": "error.cln_session_invalid",
  "PHX-CLN-0113": "error.cln_parameter_reason_required",
  "PHX-CLN-0114": "error.cln_injection_batch_invalid",
  "PHX-CLN-0115": "error.cln_image_invalid",
  "PHX-CLN-0116": "error.cln_adverse_event_invalid",
  "PHX-CLN-0117": "error.cln_device_usage_invalid",
  "PHX-CLN-0118": "error.cln_risk_assessment_invalid",
  "PHX-CLN-0119": "error.cln_safety_plan_invalid",
  "PHX-CLN-0120": "error.cln_goal_progress_invalid",
  "PHX-CLN-0121": "error.cln_consumables_invalid",
  "PHX-CLN-0122": "error.cln_image_export_invalid",
  "PHX-CLN-0123": "error.cln_record_export_invalid",
  "PHX-CLN-0124": "error.cln_annotation_invalid",
  "PHX-CLN-0125": "error.cln_tooth_chart_invalid",
  "PHX-CLN-0201": "error.cln_encounter_invalid_state",
  "PHX-CLN-0202": "error.cln_appointment_not_startable",
  "PHX-CLN-0203": "error.cln_note_not_draft",
  "PHX-CLN-0204": "error.cln_note_not_signed",
  "PHX-CLN-0205": "error.cln_note_voided",
  "PHX-CLN-0206": "error.cln_note_author_only",
  "PHX-CLN-0207": "error.cln_signature_pin_invalid",
  "PHX-CLN-0208": "error.cln_signature_pin_locked",
  "PHX-CLN-0209": "error.cln_signature_pin_not_set",
  "PHX-CLN-0210": "error.cln_absolute_contraindication",
  "PHX-CLN-0211": "error.cln_pregnancy_check_required",
  "PHX-CLN-0212": "error.cln_invalid_transition",
  "PHX-CLN-0213": "error.cln_override_invalid",
  "PHX-CLN-0214": "error.cln_session_encounter_type",
  "PHX-CLN-0215": "error.cln_fitzpatrick_required",
  "PHX-CLN-0216": "error.cln_session_correction_closed",
  "PHX-CLN-0217": "error.cln_safety_plan_required",
  "PHX-CLN-0218": "error.cln_group_note_names_participant",
  "PHX-CLN-0219": "error.cln_sensitive_export_approval_invalid",
  "PHX-CLN-0220": "error.cln_risk_follow_up_closed",
  "PHX-CLN-0221": "error.cln_note_cosign_required",
  "PHX-CLN-0222": "error.cln_cosigner_must_differ",
  "PHX-CLN-0223": "error.cln_image_consent_required",
  "PHX-CLN-0300": "error.cln_history_section_none_rejected",
  "PHX-CLN-0301": "error.cln_adverse_effect_details_required",
  "PHX-CLN-0302": "error.cln_stop_reason_required",
  "PHX-CLN-0303": "error.cln_reminder_horizon_invalid",
  "PHX-CLN-0305": "error.cln_milestone_not_found",
  "PHX-CLN-0306": "error.cln_tooth_chart_transition",
  "PHX-CLN-0307": "error.cln_dental_rule_not_payable",
  "PHX-CLN-0308": "error.cln_coded_diagnosis_required",
  "PHX-CLN-0309": "error.cln_rx_only_outcome_required",
  "PHX-CLN-0310": "error.cln_documentation_level_invalid",
  "PHX-CLN-0401": "error.cln_provider_required",
  "PHX-CMP-0101": "error.cmp_agreement_invalid",
  "PHX-CMP-0102": "error.cmp_rule_invalid",
  "PHX-CMP-0103": "error.cmp_rule_duplicate",
  "PHX-CMP-0104": "error.cmp_not_supported",
  "PHX-CMP-0105": "error.cmp_adjustment_invalid",
  "PHX-CMP-0106": "error.cmp_provider_unknown",
  "PHX-CMP-0107": "error.cmp_request_invalid",
  "PHX-CMP-0108": "error.cmp_iban_required",
  "PHX-CMP-0201": "error.cmp_invalid_transition",
  "PHX-CMP-0202": "error.cmp_agreement_overlap",
  "PHX-CMP-0203": "error.cmp_effective_date_invalid",
  "PHX-CMP-0204": "error.cmp_draft_exists",
  "PHX-CMP-0205": "error.cmp_line_not_pending",
  "PHX-CMP-0206": "error.cmp_statement_state",
  "PHX-CMP-0207": "error.cmp_amount_exceeds_payable",
  "PHX-CMP-0208": "error.cmp_owner_approval_required",
  "PHX-CMP-0209": "error.cmp_clinical_referrer_approval",
  "PHX-CMP-0210": "error.cmp_statement_locked",
  "PHX-DOC-0101": "error.document_file_invalid",
  "PHX-DOC-0102": "error.document_file_infected",
  "PHX-DOC-0103": "error.document_type_invalid",
  "PHX-DOC-0104": "error.document_link_invalid",
  "PHX-DOC-0105": "error.document_type_code_taken",
  "PHX-DOC-0106": "error.document_version_not_allowed",
  "PHX-DOC-0107": "error.document_invalid_transition",
  "PHX-DOC-0201": "error.form_definition_invalid",
  "PHX-DOC-0202": "error.form_field_code_immutable",
  "PHX-DOC-0203": "error.form_field_sensitivity_not_allowed",
  "PHX-DOC-0204": "error.form_mapping_invalid",
  "PHX-DOC-0205": "error.document_template_code_taken",
  "PHX-DOC-0206": "error.document_template_not_published",
  "PHX-DOC-0301": "error.form_submission_invalid",
  "PHX-DOC-0302": "error.form_submission_locked",
  "PHX-DOC-0303": "error.form_submission_invalid_transition",
  "PHX-DOC-0304": "error.form_request_closed",
  "PHX-DOC-0305": "error.tablet_pin_invalid",
  "PHX-DOC-0306": "error.tablet_session_closed",
  "PHX-DOC-0307": "error.doc_annotated_image_invalid",
  "PHX-DOC-0308": "error.doc_shared_field_incompatible",
  "PHX-DOC-0309": "error.doc_shared_field_invalid",
  "PHX-DOC-0310": "error.doc_upload_handoff_expired",
  "PHX-DOC-0311": "error.doc_upload_handoff_creator_only",
  "PHX-DOC-0312": "error.doc_formula_invalid",
  "PHX-DOC-0313": "error.doc_patient_visibility_approval_required",
  "PHX-DOC-0501": "error.consent_template_invalid",
  "PHX-DOC-0502": "error.consent_clauses_incomplete",
  "PHX-DOC-0503": "error.consent_signer_invalid",
  "PHX-DOC-0504": "error.consent_invalid_transition",
  "PHX-DOC-0505": "error.signature_invalid",
  "PHX-DOC-0506": "error.signature_request_closed",
  "PHX-DOC-0601": "error.print_template_unknown",
  "PHX-DOC-0602": "error.print_legal_section_required",
  "PHX-DOC-0603": "error.print_paper_unsupported",
  "PHX-DOC-0701": "error.document_share_channel_not_allowed",
  "PHX-DOC-0702": "error.document_share_no_mobile",
  "PHX-DOC-0703": "error.document_link_otp_invalid",
  "PHX-DOC-0704": "error.document_link_session_required",
  "PHX-DOC-0705": "error.document_link_otp_rate_limited",
  "PHX-DOC-0801": "error.document_rendering_unavailable",
  "PHX-DOC-0802": "error.document_scan_unavailable",
  "PHX-DOC-0901": "error.document_certificate_invalid",
  "PHX-DOC-0902": "error.document_certificate_invalid_transition",
  "PHX-DOC-1001": "error.retention_below_minimum",
  "PHX-DOC-1002": "error.retention_period_invalid",
  "PHX-DOC-1003": "error.legal_hold_invalid",
  "PHX-DOC-1004": "error.legal_hold_already_released",
  "PHX-DOC-1005": "error.destruction_invalid_transition",
  "PHX-DOC-1006": "error.destruction_approval_required",
  "PHX-DOC-1007": "error.destruction_run_empty",
  "PHX-ENG-0101": "error.eng_lead_invalid",
  "PHX-ENG-0102": "error.eng_consultation_invalid",
  "PHX-ENG-0103": "error.eng_followup_invalid",
  "PHX-ENG-0104": "error.eng_subject_unknown",
  "PHX-ENG-0105": "error.eng_outcome_required",
  "PHX-ENG-0106": "error.eng_lost_reason_required",
  "PHX-ENG-0107": "error.eng_assignee_unknown",
  "PHX-ENG-0108": "error.eng_assignment_invalid",
  "PHX-ENG-0109": "error.eng_rule_invalid",
  "PHX-ENG-0110": "error.eng_survey_invalid",
  "PHX-ENG-0111": "error.eng_survey_answer_invalid",
  "PHX-ENG-0112": "error.eng_segment_invalid",
  "PHX-ENG-0113": "error.eng_campaign_invalid",
  "PHX-ENG-0114": "error.eng_loyalty_invalid",
  "PHX-ENG-0201": "error.eng_invalid_transition",
  "PHX-ENG-0202": "error.eng_patient_required",
  "PHX-ENG-0203": "error.eng_contact_not_allowed",
  "PHX-ENG-0204": "error.eng_quote_exists",
  "PHX-ENG-0205": "error.eng_survey_already_answered",
  "PHX-ENG-0206": "error.eng_campaign_approval_required",
  "PHX-ENG-0207": "error.eng_self_referral",
  "PHX-ENG-0208": "error.eng_referral_cap",
  "PHX-GEN-0001": "error.validation",
  "PHX-GEN-0002": "error.not_found",
  "PHX-GEN-0003": "error.conflict",
  "PHX-GEN-0004": "error.forbidden",
  "PHX-GEN-0005": "error.unauthenticated",
  "PHX-GEN-0008": "error.idempotency_conflict",
  "PHX-GEN-0429": "error.too_many_requests",
  "PHX-IAM-0003": "error.membership_stale",
  "PHX-IAM-0103": "error.no_active_membership",
  "PHX-IAM-0104": "error.branch_not_allowed",
  "PHX-IAM-0201": "error.already_member",
  "PHX-IAM-0202": "error.last_owner_protected",
  "PHX-IAM-0203": "error.role_not_assignable",
  "PHX-IAM-0204": "error.invitation_unavailable",
  "PHX-IAM-0205": "error.invitation_sign_in_required",
  "PHX-IAM-0206": "error.invitation_other_user",
  "PHX-IAM-0301": "error.otp_invalid",
  "PHX-IAM-0302": "error.otp_rate_limited",
  "PHX-IAM-0303": "error.password_rejected",
  "PHX-IAM-0304": "error.second_factor_required",
  "PHX-IAM-0305": "error.identity_provider_unavailable",
  "PHX-IAM-0401": "error.national_id_duplicate",
  "PHX-IAM-0402": "error.provider_requires_profile",
  "PHX-IAM-0403": "error.provider_exists",
  "PHX-IAM-0404": "error.specialty_unknown",
  "PHX-IAM-0405": "error.credential_duplicate",
  "PHX-IAM-0406": "error.credential_file_invalid",
  "PHX-IAM-0407": "error.not_a_provider",
  "PHX-IAM-0408": "error.signature_image_invalid",
  "PHX-IAM-0501": "error.role_exceeds_creator",
  "PHX-IAM-0502": "error.role_locked",
  "PHX-IAM-0503": "error.role_in_use",
  "PHX-IAM-0504": "error.role_code_duplicate",
  "PHX-IAM-0505": "error.approval_limit_exceeds_own",
  "PHX-IAM-0506": "error.network_restriction_invalid",
  "PHX-IAM-0601": "error.approval_rejected",
  "PHX-IAM-0602": "error.approver_limit_insufficient",
  "PHX-IAM-0603": "error.approval_pin_locked",
  "PHX-IAM-0604": "error.approval_unavailable",
  "PHX-IAM-0605": "error.self_approval",
  "PHX-IAM-0701": "error.mfa_required",
  "PHX-IAM-0702": "error.recovery_code_invalid",
  "PHX-IAM-0801": "error.reauthentication_required",
  "PHX-IAM-0802": "error.access_override_not_reviewable",
  "PHX-IAM-0803": "error.access_override_self_review",
  "PHX-IAM-0804": "error.support_read_only",
  "PHX-IAM-0805": "error.audit_export_too_large",
  "PHX-IAM-0806": "error.device_pairing_invalid",
  "PHX-IAM-0807": "error.device_credentials_invalid",
  "PHX-IAM-0808": "error.device_scope_denied",
  "PHX-IAM-0809": "error.device_account_revoked",
  "PHX-INS-0101": "error.ins_insurer_invalid",
  "PHX-INS-0102": "error.ins_contract_invalid",
  "PHX-INS-0103": "error.ins_plan_invalid",
  "PHX-INS-0104": "error.ins_coverage_rule_invalid",
  "PHX-INS-0105": "error.ins_cap_invalid",
  "PHX-INS-0106": "error.ins_exclusion_invalid",
  "PHX-INS-0107": "error.ins_coverage_invalid",
  "PHX-INS-0108": "error.ins_eligibility_invalid",
  "PHX-INS-0109": "error.ins_preauth_invalid",
  "PHX-INS-0110": "error.ins_referral_invalid",
  "PHX-INS-0111": "error.ins_claim_invalid",
  "PHX-INS-0112": "error.ins_deduction_invalid",
  "PHX-INS-0113": "error.ins_appeal_invalid",
  "PHX-INS-0114": "error.ins_remittance_invalid",
  "PHX-INS-0115": "error.ins_settlement_file_invalid",
  "PHX-INS-0116": "error.ins_write_off_invalid",
  "PHX-INS-0201": "error.ins_insurer_code_taken",
  "PHX-INS-0202": "error.ins_contract_overlap",
  "PHX-INS-0203": "error.ins_invalid_transition",
  "PHX-INS-0204": "error.ins_coverage_overlap",
  "PHX-INS-0205": "error.ins_in_use",
  "PHX-INS-0206": "error.ins_principal_invalid",
  "PHX-INS-0207": "error.ins_claim_needs_fix",
  "PHX-INS-0208": "error.ins_deduction_exceeds_claim",
  "PHX-INS-0209": "error.ins_allocation_exceeds",
  "PHX-INS-0210": "error.ins_appeal_window_closed",
  "PHX-INT-0101": "error.integration_adapter_unknown",
  "PHX-INT-0102": "error.integration_adapter_not_allowed",
  "PHX-INT-0103": "error.integration_settings_invalid",
  "PHX-INT-0104": "error.integration_credential_level_mismatch",
  "PHX-INT-0105": "error.integration_secret_name_invalid",
  "PHX-INT-0106": "error.integration_connection_test_required",
  "PHX-INT-0107": "error.integration_branch_invalid",
  "PHX-INT-0108": "error.integration_dead_letter_not_open",
  "PHX-INT-0109": "error.integration_reason_required",
  "PHX-INT-0110": "error.integration_agent_pairing_invalid",
  "PHX-INT-0111": "error.integration_agent_csr_invalid",
  "PHX-INT-0112": "error.integration_agent_state_invalid",
  "PHX-INT-0113": "error.integration_agent_device_role_invalid",
  "PHX-INT-0114": "error.integration_agent_update_window_invalid",
  "PHX-INT-0115": "error.integration_agent_test_requires_simulator",
  "PHX-INT-0206": "error.integration_no_endpoint",
  "PHX-INT-0300": "error.integration_activation_setting_missing",
  "PHX-INT-0301": "error.integration_webhook_unauthorized",
  "PHX-INT-0302": "error.integration_agent_unauthorized",
  "PHX-INT-0310": "error.provider_credential_branch_missing",
  "PHX-INT-0311": "error.tamin_doctor_identity_invalid",
  "PHX-INT-0312": "error.provider_credential_expired",
  "PHX-INT-0313": "error.credential_renewal_link_invalid",
  "PHX-INT-0314": "error.sakhad_prescribing_id_required",
  "PHX-INT-0315": "error.insurer_login_method_not_supported",
  "PHX-INT-0316": "error.insurer_qr_expired",
  "PHX-INT-0317": "error.call_initiator_not_owner",
  "PHX-INT-0318": "error.initiating_action_stale",
  "PHX-INT-0319": "error.integration_provider_message",
  "PHX-INT-0320": "error.credential_renewal_rate_limited",
  "PHX-INT-0330": "error.tamin_token_expired",
  "PHX-INT-0331": "error.tamin_doctor_not_registered",
  "PHX-INT-0332": "error.tamin_patient_national_id_invalid",
  "PHX-INT-0333": "error.tamin_patient_mobile_invalid",
  "PHX-INT-0334": "error.tamin_service_code_unknown",
  "PHX-INT-0335": "error.tamin_prescription_type_invalid",
  "PHX-INT-0336": "error.tamin_service_type_mismatch",
  "PHX-INT-0337": "error.tamin_lab_subgroup_required",
  "PHX-INT-0338": "error.tamin_quantity_invalid",
  "PHX-INT-0339": "error.tamin_drug_usage_invalid",
  "PHX-INT-0340": "error.tamin_date_invalid",
  "PHX-INT-0341": "error.tamin_duplicate_prescription",
  "PHX-INT-0342": "error.tamin_input_invalid",
  "PHX-INT-0343": "error.tamin_physiotherapy_invalid",
  "PHX-INT-0344": "error.tamin_dental_flag_required",
  "PHX-INT-0345": "error.tamin_edit_window_closed",
  "PHX-INT-0346": "error.insurer_auth_state_mismatch",
  "PHX-INT-0347": "error.insurer_staff_session_not_allowed",
  "PHX-INT-0348": "error.insurer_redirect_uri_invalid",
  "PHX-INT-0349": "error.insurer_siam_membership_missing",
  "PHX-INV-0101": "error.inv_item_code_taken",
  "PHX-INV-0102": "error.inv_item_invalid",
  "PHX-INV-0103": "error.inv_category_code_taken",
  "PHX-INV-0104": "error.inv_category_not_found",
  "PHX-INV-0105": "error.inv_category_not_empty",
  "PHX-INV-0106": "error.inv_barcode_taken",
  "PHX-INV-0107": "error.inv_unit_conversion_invalid",
  "PHX-INV-0108": "error.inv_sale_service_invalid",
  "PHX-INV-0109": "error.inv_supplier_invalid",
  "PHX-INV-0110": "error.inv_supplier_unknown",
  "PHX-INV-0111": "error.inv_batch_number_taken",
  "PHX-INV-0112": "error.inv_batch_invalid",
  "PHX-INV-0114": "error.inv_supplier_national_id_taken",
  "PHX-INV-0115": "error.inv_tracking_uid_invalid",
  "PHX-INV-0201": "error.inv_item_code_locked",
  "PHX-INV-0202": "error.inv_item_delete_forbidden",
  "PHX-INV-0203": "error.inv_invalid_transition",
  "PHX-INV-0204": "error.inv_item_inactive",
  "PHX-INV-0301": "error.inv_warehouse_invalid",
  "PHX-INV-0302": "error.inv_warehouse_taken",
  "PHX-INV-0303": "error.inv_insufficient_stock",
  "PHX-INV-0304": "error.inv_batch_required",
  "PHX-INV-0305": "error.inv_batch_not_selectable",
  "PHX-INV-0306": "error.inv_open_container_invalid",
  "PHX-INV-0307": "error.inv_batch_already_recalled",
  "PHX-INV-0308": "error.inv_stocktake_invalid",
  "PHX-INV-0309": "error.inv_valuation_change_not_allowed",
  "PHX-INV-0310": "error.inv_document_invalid",
  "PHX-INV-0311": "error.inv_sales_return_resolved",
  "PHX-INV-0312": "error.inv_reorder_rule_invalid",
  "PHX-INV-0313": "error.inv_procurement_invalid",
  "PHX-INV-0314": "error.inv_purchase_approval_required",
  "PHX-INV-0315": "error.inv_exceeds_order",
  "PHX-INV-0316": "error.inv_exceeds_invoiceable",
  "PHX-INV-0317": "error.inv_payment_exceeds_balance",
  "PHX-INV-0318": "error.inv_invoice_immutable",
  "PHX-INV-0319": "error.inv_supplier_invoice_number_taken",
  "PHX-INV-0320": "error.inv_tracking_uid_state",
  "PHX-MED-0101": "error.med_prescription_item_invalid",
  "PHX-MED-0102": "error.med_drug_unknown",
  "PHX-MED-0103": "error.med_encounter_invalid",
  "PHX-MED-0104": "error.med_catalog_entry_invalid",
  "PHX-MED-0105": "error.med_catalog_entry_duplicate",
  "PHX-MED-0106": "error.med_order_invalid",
  "PHX-MED-0107": "error.med_partner_or_panel_invalid",
  "PHX-MED-0108": "error.med_result_invalid",
  "PHX-MED-0109": "error.med_referral_invalid",
  "PHX-MED-0110": "error.med_override_invalid",
  "PHX-MED-0111": "error.med_repeat_invalid",
  "PHX-MED-0112": "error.med_referrer_invalid",
  "PHX-MED-0113": "error.med_national_rule_violation",
  "PHX-MED-0114": "error.med_insurer_code_map_invalid",
  "PHX-MED-0115": "error.med_national_submission_invalid",
  "PHX-MED-0116": "error.med_inbound_lab_invalid",
  "PHX-MED-0117": "error.med_partner_code_map_invalid",
  "PHX-MED-0201": "error.med_prescription_invalid_transition",
  "PHX-MED-0202": "error.med_critical_alerts_unresolved",
  "PHX-MED-0203": "error.med_controlled_reason_required",
  "PHX-MED-0204": "error.med_controlled_repeat_forbidden",
  "PHX-MED-0205": "error.med_order_invalid_transition",
  "PHX-MED-0206": "error.med_result_invalid_transition",
  "PHX-MED-0207": "error.med_result_contact_required",
  "PHX-MED-0208": "error.med_referral_invalid_transition",
  "PHX-MED-0209": "error.med_national_submission_invalid_transition",
  "PHX-MED-0210": "error.med_national_change_not_allowed",
  "PHX-MED-0300": "error.med_referral_coding_invalid",
  "PHX-MED-0301": "error.med_national_referral_code_invalid",
  "PHX-MED-0302": "error.med_national_credential_unavailable",
  "PHX-MED-0303": "error.med_referral_feedback_required",
  "PHX-MED-0304": "error.med_referral_date_too_early",
  "PHX-MED-0305": "error.med_referral_feedback_immutable",
  "PHX-MED-0306": "error.med_referral_slot_taken",
  "PHX-MED-0320": "error.med_effective_date_out_of_range",
  "PHX-MED-0321": "error.med_future_effective_unsupported",
  "PHX-MED-0322": "error.med_order_repeat_invalid",
  "PHX-MED-0323": "error.med_contrast_modifier_required",
  "PHX-MED-0324": "error.med_body_region_required",
  "PHX-MED-0325": "error.med_approver_not_eligible",
  "PHX-MED-0326": "error.med_approval_expired",
  "PHX-MED-0327": "error.med_approval_locked",
  "PHX-MED-0328": "error.med_self_approval_forbidden",
  "PHX-MED-0329": "error.med_voice_engine_unavailable",
  "PHX-MED-0330": "error.med_insurer_document_unavailable",
  "PHX-MED-0331": "error.med_referential_service_item_invalid",
  "PHX-MED-0332": "error.med_referential_prescription_not_found",
  "PHX-MED-0333": "error.med_nursing_requires_siam",
  "PHX-MED-0334": "error.med_nursing_requires_medical_service",
  "PHX-MED-0335": "error.med_nurse_session_required",
  "PHX-MED-0336": "error.med_nursing_item_not_actionable",
  "PHX-MED-0337": "error.med_patient_flag_disease_invalid",
  "PHX-MED-0338": "error.med_support_level_required",
  "PHX-MED-0339": "error.med_supplementary_service_unsupported",
  "PHX-MED-0401": "error.med_prescriber_not_licensed",
  "PHX-MED-0402": "error.med_registration_missing",
  "PHX-MED-0403": "error.med_foreign_credential",
  "PHX-MED-0404": "error.med_national_registration_not_valid",
  "PHX-MSG-0101": "error.message_template_variable_unknown",
  "PHX-MSG-0102": "error.message_template_variable_clinical",
  "PHX-MSG-0103": "error.message_template_body_invalid",
  "PHX-MSG-0104": "error.message_template_not_editable",
  "PHX-MSG-0105": "error.message_template_language_unsupported",
  "PHX-MSG-0201": "error.message_free_text_forbidden",
  "PHX-MSG-0202": "error.message_free_text_length",
  "PHX-MSG-0203": "error.bulk_notice_marketing",
  "PHX-MSG-0204": "error.bulk_notice_no_recipients",
  "PHX-MSG-0205": "error.bulk_notice_range_invalid",
  "PHX-MSG-0301": "error.notification_rule_code_taken",
  "PHX-MSG-0302": "error.notification_rule_invalid",
  "PHX-MSG-0401": "error.message_dedicated_line_unavailable",
  "PHX-MSG-0402": "error.message_quiet_hours_invalid",
  "PHX-MSG-0501": "error.inbound_message_not_open",
  "PHX-MSG-0601": "error.message_recipient_no_mobile",
  "PHX-MSG-0701": "error.push_subscription_invalid",
  "PHX-MSG-0702": "error.push_unavailable",
  "PHX-MSG-0703": "error.notification_preference_invalid",
  "PHX-MSG-0710": "error.messenger_provider_invalid",
  "PHX-MSG-0711": "error.messenger_unavailable",
  "PHX-MSG-0712": "error.messenger_no_mobile",
  "PHX-MSG-0801": "error.message_report_range_invalid",
  "PHX-ORG-0101": "error.department_code_taken",
  "PHX-ORG-0102": "error.department_depth_exceeded",
  "PHX-ORG-0103": "error.department_parent_invalid",
  "PHX-ORG-0104": "error.department_head_invalid",
  "PHX-ORG-0201": "error.room_code_taken",
  "PHX-ORG-0202": "error.room_branch_immutable",
  "PHX-ORG-0203": "error.room_has_devices",
  "PHX-ORG-0204": "error.room_deactivation_unconfirmed",
  "PHX-ORG-0205": "error.room_department_invalid",
  "PHX-ORG-0206": "error.org_unit_code_taken",
  "PHX-ORG-0207": "error.org_unit_room_inactive",
  "PHX-ORG-0301": "error.org_device_serial_taken",
  "PHX-ORG-0302": "error.org_device_code_taken",
  "PHX-ORG-0303": "error.org_device_retired",
  "PHX-ORG-0304": "error.org_device_status_transition",
  "PHX-ORG-0305": "error.org_device_room_invalid",
  "PHX-ORG-0306": "error.org_relocation_effective_required",
  "PHX-ORG-0307": "error.org_device_type_code_taken",
  "PHX-ORG-0308": "error.org_device_type_in_use",
  "PHX-ORG-0309": "error.org_device_type_unknown",
  "PHX-ORG-0310": "error.org_cost_rate_basis_invalid",
  "PHX-ORG-0311": "error.org_cost_rate_conflict",
  "PHX-ORG-0312": "error.org_certificate_dates_invalid",
  "PHX-ORG-0313": "error.org_contract_range_invalid",
  "PHX-ORG-0314": "error.org_supplier_invalid",
  "PHX-ORG-0401": "error.resource_tag_code_taken",
  "PHX-ORG-0402": "error.resource_tag_system_readonly",
  "PHX-ORG-0403": "error.resource_tag_in_use",
  "PHX-ORG-0404": "error.resource_tag_assigned",
  "PHX-ORG-0405": "error.resource_tag_unknown",
  "PHX-ORG-0501": "error.org_block_in_past",
  "PHX-ORG-0502": "error.org_block_range_invalid",
  "PHX-ORG-0503": "error.org_block_recurrence_too_long",
  "PHX-ORG-0504": "error.org_block_not_cancellable",
  "PHX-ORG-0505": "error.org_resource_unknown",
  "PHX-ORG-0601": "error.org_counter_decrease",
  "PHX-ORG-0602": "error.org_counter_start_below_last",
  "PHX-ORG-0603": "error.org_device_no_counter",
  "PHX-ORG-0604": "error.org_counter_end_below_start",
  "PHX-ORG-0701": "error.org_work_order_transition",
  "PHX-ORG-0702": "error.org_work_order_assignee_invalid",
  "PHX-ORG-0801": "error.org_maintenance_plan_invalid",
  "PHX-ORG-0802": "error.org_maintenance_transition",
  "PHX-PAT-0101": "error.patient_national_id_invalid",
  "PHX-PAT-0102": "error.patient_birth_date_invalid",
  "PHX-PAT-0103": "error.patient_identity_locked",
  "PHX-PAT-0104": "error.patient_identity_reason_required",
  "PHX-PAT-0105": "error.patient_identifier_invalid",
  "PHX-PAT-0106": "error.patient_identity_inquiry_not_applicable",
  "PHX-PAT-0107": "error.patient_not_temporary",
  "PHX-PAT-0108": "error.patient_merged",
  "PHX-PAT-0201": "error.patient_card_revoked",
  "PHX-PAT-0202": "error.patient_card_invalid",
  "PHX-PAT-0203": "error.patient_photo_invalid",
  "PHX-PAT-0301": "error.patient_national_id_duplicate",
  "PHX-PAT-0302": "error.patient_probable_duplicate",
  "PHX-PAT-0303": "error.patient_merge_invalid",
  "PHX-PAT-0304": "error.patient_merge_national_id_conflict",
  "PHX-PAT-0305": "error.patient_unmerge_window_passed",
  "PHX-PAT-0401": "error.patient_primary_mobile_required",
  "PHX-PAT-0402": "error.patient_contact_duplicate",
  "PHX-PAT-0501": "error.patient_relation_invalid",
  "PHX-PAT-0502": "error.patient_consent_guardian_required",
  "PHX-PAT-0503": "error.patient_companion_consent_required",
  "PHX-PAT-0504": "error.patient_relation_duplicate",
  "PHX-PAT-0505": "error.patient_family_member_taken",
  "PHX-PAT-0506": "error.patient_family_invalid",
  "PHX-PAT-0601": "error.patient_referral_source_locked",
  "PHX-PAT-0602": "error.patient_referral_source_invalid",
  "PHX-PAT-0603": "error.patient_referral_source_code_taken",
  "PHX-PAT-0701": "error.patient_file_number_start_too_low",
  "PHX-PAT-0801": "error.patient_tag_clinical_content",
  "PHX-PAT-0802": "error.patient_tag_code_taken",
  "PHX-PAT-0805": "error.patient_masked_profile",
  "PHX-PAT-0901": "error.patient_deceased_date_invalid",
  "PHX-PAT-0902": "error.patient_deceased_state",
  "PHX-PAT-1001": "error.patient_portal_otp_rate_limited",
  "PHX-PAT-1002": "error.patient_portal_otp_invalid",
  "PHX-PAT-1003": "error.patient_portal_session_invalid",
  "PHX-PAT-1004": "error.patient_portal_identity_required",
  "PHX-PAT-1005": "error.patient_portal_link_exists",
  "PHX-PAT-1006": "error.patient_portal_registration_conflict",
  "PHX-PAT-1007": "error.patient_portal_consent_required",
  "PHX-PAT-1008": "error.patient_portal_dependent_not_allowed",
  "PHX-PAT-1009": "error.patient_portal_link_state",
  "PHX-PAT-1010": "error.patient_portal_gov_sso_unavailable",
  "PHX-PAT-1011": "error.patient_portal_gov_sso_mismatch",
  "PHX-PAT-1101": "error.patient_data_request_state",
  "PHX-PAT-1102": "error.patient_data_request_invalid",
  "PHX-PAT-1103": "error.patient_data_request_pending",
  "PHX-PAT-1104": "error.patient_data_export_link_expired",
  "PHX-PLT-0101": "error.tenant_slug_taken",
  "PHX-PLT-0102": "error.shahkar_mismatch",
  "PHX-PLT-0103": "error.tenant_invalid_transition",
  "PHX-PLT-0104": "error.plan_not_available",
  "PHX-PLT-0105": "error.tenant_slug_immutable",
  "PHX-PLT-0106": "error.signup_duplicate_trial",
  "PHX-PLT-0107": "error.otp_invalid",
  "PHX-PLT-0108": "error.signup_rejected",
  "PHX-PLT-0109": "error.otp_rate_limited",
  "PHX-PLT-0201": "error.plan_code_taken",
  "PHX-PLT-0202": "error.plan_version_incomplete",
  "PHX-PLT-0203": "error.plan_version_not_draft",
  "PHX-PLT-0204": "error.sms_credit_charge_invalid",
  "PHX-PLT-0301": "error.branch_code_taken",
  "PHX-PLT-0302": "error.branch_ownership_retroactive",
  "PHX-PLT-0303": "error.geo_division_invalid",
  "PHX-PLT-0304": "error.branch_invalid_transition",
  "PHX-PLT-0305": "error.branch_last_active",
  "PHX-PLT-0306": "error.branch_has_open_items",
  "PHX-PLT-0307": "error.technical_director_invalid",
  "PHX-PLT-0308": "error.holiday_bulk_delete",
  "PHX-PLT-0309": "error.holiday_multi_branch",
  "PHX-PLT-0402": "error.limit_reached",
  "PHX-PLT-0403": "error.feature_disabled",
  "PHX-PLT-0423": "error.tenant_read_only",
  "PHX-PLT-0501": "error.license_invalid",
  "PHX-PLT-0502": "error.reference_file_invalid",
  "PHX-PLT-0503": "error.reference_version_not_draft",
  "PHX-PLT-0504": "error.license_version_out_of_range",
  "PHX-PLT-0505": "error.reference_bundle_invalid",
  "PHX-PLT-0506": "error.license_issue_invalid",
  "PHX-PLT-0601": "error.entitlement_override_invalid",
  "PHX-PLT-0701": "error.import_file_too_large",
  "PHX-PLT-0702": "error.import_too_many_rows",
  "PHX-PLT-0703": "error.import_file_unreadable",
  "PHX-PLT-0704": "error.import_type_unavailable",
  "PHX-PLT-0705": "error.import_mapping_invalid",
  "PHX-PLT-0706": "error.import_invalid_transition",
  "PHX-PLT-0707": "error.import_dependency_pending",
  "PHX-PLT-0708": "error.import_invalid_rows",
  "PHX-PLT-0709": "error.import_rollback_window_expired",
  "PHX-PLT-0710": "error.import_rollback_has_dependents",
  "PHX-PLT-0711": "error.import_file_expired",
  "PHX-PLT-0712": "error.import_nothing_valid",
  "PHX-PLT-0713": "error.import_legacy_source_invalid",
  "PHX-PLT-0801": "error.onboarding_step_unavailable",
  "PHX-PLT-0802": "error.onboarding_step_required",
  "PHX-PLT-0803": "error.onboarding_incomplete",
  "PHX-PLT-0804": "error.terms_not_accepted",
  "PHX-PLT-0805": "error.tenant_already_live",
  "PHX-PLT-0901": "error.branding_logo_invalid",
  "PHX-PLT-0902": "error.holiday_invalid",
  "PHX-PLT-0903": "error.holiday_overlap",
  "PHX-PLT-1101": "error.support_access_invalid_transition",
  "PHX-PLT-1102": "error.support_access_invalid",
  "PHX-PLT-1103": "error.announcement_invalid",
  "PHX-PLT-1201": "error.subscription_not_purchasable",
  "PHX-PLT-1202": "error.subscription_payment_unavailable",
  "PHX-PLT-1203": "error.downgrade_limit_exceeded",
  "PHX-PLT-1204": "error.plan_change_invalid",
  "PHX-PLT-1205": "error.subscription_payment_failed",
  "PHX-PLT-1206": "error.subscription_invoice_not_payable",
  "PHX-PLT-1207": "error.subscription_quote_invalid",
  "PHX-PLT-1208": "error.trial_extension_invalid",
  "PHX-PLT-1301": "error.export_in_progress",
  "PHX-PLT-1302": "error.export_link_expired",
  "PHX-PLT-1303": "error.ownership_transfer_invalid",
  "PHX-PLT-1304": "error.demo_tenant_invalid",
  "PHX-RPT-0101": "error.rpt_range_invalid",
  "PHX-SCH-0101": "error.schedule_branch_overlap",
  "PHX-SCH-0102": "error.schedule_block_invalid",
  "PHX-SCH-0103": "error.schedule_template_overlap",
  "PHX-SCH-0104": "error.schedule_exception_impact_unconfirmed",
  "PHX-SCH-0105": "error.schedule_exception_invalid",
  "PHX-SCH-0106": "error.schedule_validity_invalid",
  "PHX-SCH-0107": "error.schedule_exception_not_pending",
  "PHX-SCH-0201": "error.slot_unavailable",
  "PHX-SCH-0202": "error.patient_overlap",
  "PHX-SCH-0203": "error.walk_in_no_slot",
  "PHX-SCH-0204": "error.overbook_limit_reached",
  "PHX-SCH-0205": "error.service_not_bookable",
  "PHX-SCH-0206": "error.provider_not_eligible",
  "PHX-SCH-0207": "error.patient_not_bookable",
  "PHX-SCH-0208": "error.booking_restricted",
  "PHX-SCH-0209": "error.hold_unavailable",
  "PHX-SCH-0210": "error.combined_gap_exceeded",
  "PHX-SCH-0211": "error.series_invalid",
  "PHX-SCH-0212": "error.series_conflict",
  "PHX-SCH-0213": "error.online_quota_exceeded",
  "PHX-SCH-0214": "error.not_bookable_online",
  "PHX-SCH-0301": "error.appointment_invalid_transition",
  "PHX-SCH-0302": "error.cancel_reason_required",
  "PHX-SCH-0303": "error.no_show_too_early",
  "PHX-SCH-0304": "error.no_show_correction_expired",
  "PHX-SCH-0305": "error.check_in_not_today",
  "PHX-SCH-0306": "error.deposit_waiver_reason_required",
  "PHX-SCH-0307": "error.not_appointment_provider",
  "PHX-SCH-0308": "error.admission_rule_invalid",
  "PHX-SCH-0309": "error.admission_rule_blocked",
  "PHX-SCH-0310": "error.admission_override_denied",
  "PHX-SCH-0311": "error.appointment_locked",
  "PHX-SCH-0312": "error.bulk_closure_invalid",
  "PHX-SCH-0313": "error.restore_failed",
  "PHX-SCH-0314": "error.horizon_end_invalid",
  "PHX-SCH-0330": "error.referral_service_invalid",
  "PHX-SCH-0331": "error.referral_location_invalid",
  "PHX-SCH-0332": "error.referral_code_required",
  "PHX-SCH-0333": "error.referral_publish_blocked",
  "PHX-SCH-0401": "error.cancel_reason_code_taken",
  "PHX-SCH-0501": "error.booking_policy_invalid",
  "PHX-SCH-0601": "error.waitlist_entry_invalid",
  "PHX-SCH-0602": "error.waitlist_offer_closed",
  "PHX-SCH-0701": "error.reschedule_item_closed",
  "PHX-SCH-0801": "error.group_session_invalid",
  "PHX-SCH-0802": "error.group_already_enrolled",
  "PHX-SCH-0803": "error.group_session_closed",
  "PHX-SCH-0804": "error.group_session_has_participants",
  "PHX-SCH-0901": "error.channel_invalid",
  "PHX-SCH-0902": "error.channel_mapping_duplicate",
  "PHX-SCH-0903": "error.channel_quota_invalid",
  "PHX-SCH-0904": "error.channel_inactive",
  "PHX-TEL-0101": "error.tel_not_virtual_service",
  "PHX-TEL-0102": "error.tel_consent_required",
  "PHX-TEL-0103": "error.tel_deposit_required",
  "PHX-TEL-0201": "error.tel_room_not_found",
  "PHX-TEL-0202": "error.tel_waiting_room_not_open",
  "PHX-TEL-0203": "error.tel_room_expired",
  "PHX-TEL-0204": "error.tel_portal_session_required",
  "PHX-TEL-0205": "error.tel_identity_not_verified",
  "PHX-TEL-0301": "error.tel_session_not_active",
  "PHX-TEL-0302": "error.tel_session_already_active",
  "PHX-TEL-0303": "error.tel_mode_downgrade_only",
  "PHX-TEL-0304": "error.tel_video_provider_unavailable",
  "PHX-TEL-0401": "error.tel_restricted_drug",
  "PHX-TEL-0501": "error.tel_no_technical_failure"
};
